import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';
import api from '../api';

// Context globale col profilo (record DB) del fornitore loggato.
// Serve a mostrare lo stesso avatar (users.avatar_url) ovunque — navbar inclusa —
// e ad aggiornarlo subito dopo l'upload senza ricaricare la pagina.
const ProfiloContext = createContext({ profilo: null, loading: true, refetch: () => {}, setAvatar: () => {} });

export function ProfiloProvider({ children }) {
  const { isSignedIn, isLoaded } = useAuth();
  const [profilo, setProfilo] = useState(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!isSignedIn) {
      setProfilo(null);
      setLoading(false);
      return;
    }
    try {
      const res = await api.get('/auth/profilo');
      setProfilo(res.data);
    } catch (_e) {
      setProfilo(null);
    } finally {
      setLoading(false);
    }
  }, [isSignedIn]);

  useEffect(() => {
    if (!isLoaded) return;
    refetch();
  }, [isLoaded, refetch]);

  // Aggiorna solo l'avatar in locale (dopo un upload riuscito).
  const setAvatar = useCallback((url) => {
    setProfilo((prev) => (prev ? { ...prev, avatar_url: url } : prev));
  }, []);

  return (
    <ProfiloContext.Provider value={{ profilo, loading, refetch, setAvatar }}>
      {children}
    </ProfiloContext.Provider>
  );
}

export function useProfilo() {
  return useContext(ProfiloContext);
}

export default ProfiloContext;
